module.exports = __webpack_public_path__ + "img/us_未标题-2.c5c80ed5.jpg";